// eslint-disable
// this is an auto generated file. This will be overwritten

export const updateClient = `mutation UpdateClient($input: UpdateClientInput!) {
  updateClient(input: $input) {
    clientName
    addressCountry
    addressLine1
    addressLine2
    addressState
    addressZipCode
    dateRegistered
    govtRegistrationId
    name
    owner
    phone
    website
    highdays
    meddays
    lowdays
    tier
    maxWebApps
    maxConcurrentTests
    accountStatus
  }
}
`;
export const changeOwner = `mutation ChangeOwner($input: String!) {
  changeOwner(input: $input) {
    given_name
    family_name
    avatar
    emailaddress
    displayName
    phone
    role
    currentipaddress
    previpaddress
    city
    country
  }
}
`;
export const createUser = `mutation CreateUser($input: CreateUserInput!) {
  createUser(input: $input)
}
`;
export const welcomeNewUser = `mutation WelcomeNewUser($input: WelcomeUserInput) {
  welcomeNewUser(input: $input)
}
`;
export const deleteUser = `mutation DeleteUser($input: DeleteUserInput!) {
  deleteUser(input: $input)
}
`;
export const resetUserMfa = `mutation ResetUserMfa($input: ResetUserMfaInput!) {
  resetUserMfa(input: $input)
}
`;
export const changeUserRole = `mutation ChangeUserRole($input: ChangeUserRoleInput!) {
  changeUserRole(input: $input) {
    given_name
    family_name
    avatar
    emailaddress
    displayName
    phone
    role
    currentipaddress
    previpaddress
    city
    country
  }
}
`;
export const changeAvatar = `mutation ChangeAvatar($input: ChangeAvatarInput!) {
  changeAvatar(input: $input)
}
`;
export const changeDisplayName = `mutation ChangeDisplayName($input: ChangeDisplayNameInput!) {
  changeDisplayName(input: $input)
}
`;
export const getFileUploadUrl = `mutation GetFileUploadUrl($input: GetFileUploadUrlInput!) {
  getFileUploadUrl(input: $input) {
    uploadUrl
    fileKey
  }
}
`;
// Integration mutations
export const createIntegration = `mutation CreateIntegration($input: CreateIntegrationInput!) {
  createIntegration(input: $input) {
    id
    webAppId
    integrationType
    displayName
    enabled
    createdAt
    updatedAt
    connectionConfig
    eventFilter
    credentialId
    lastDeliveryStatus
    lastErrorMessage
    consecutiveFailures
  }
}
`;
export const updateIntegration = `mutation UpdateIntegration($input: UpdateIntegrationInput!) {
  updateIntegration(input: $input) {
    id
    webAppId
    integrationType
    displayName
    enabled
    updatedAt
    connectionConfig
    eventFilter
    credentialId
    lastDeliveryStatus
    lastErrorMessage
    consecutiveFailures
  }
}
`;
export const deleteIntegration = `mutation DeleteIntegration($input: IDInput!) {
  deleteIntegration(input: $input)
}
`;
export const toggleIntegration = `mutation ToggleIntegration($input: ToggleIntegrationInput!) {
  toggleIntegration(input: $input) {
    id
    enabled
    consecutiveFailures
    lastErrorMessage
  }
}
`;
export const testIntegrationConnection = `mutation TestIntegrationConnection($input: TestIntegrationInput!) {
  testIntegrationConnection(input: $input) {
    success
    message
  }
}
`;
export const createIntegrationCredential = `mutation CreateIntegrationCredential($input: CreateIntegrationCredentialInput!) {
  createIntegrationCredential(input: $input) {
    id
    integrationType
    displayName
    credentialType
    maskedSuffix
    credentialLastRotated
    credentialExpiresAt
    createdAt
    updatedAt
    createdBy
  }
}
`;
export const updateIntegrationCredential = `mutation UpdateIntegrationCredential($input: UpdateIntegrationCredentialInput!) {
  updateIntegrationCredential(input: $input) {
    id
    integrationType
    displayName
    credentialType
    maskedSuffix
    credentialLastRotated
    credentialExpiresAt
    updatedAt
  }
}
`;
export const deleteIntegrationCredential = `mutation DeleteIntegrationCredential($input: IDInput!) {
  deleteIntegrationCredential(input: $input)
}
`;
export const updatePassphrase = `mutation UpdatePassphrase($input: UpdatePassphraseInput!) {
  updatePassphrase(input: $input)
}
`;
export const createWebApplication = `mutation CreateWebApplication($input: CreateWebApplicationInput!) {
  createWebApplication(input: $input) {
    id
    name
    url
    owner
    verificationString
    ownershipVerified
    allowedLinks
    deniedLinks
    apiDomains
    maxRequestsPerSecond
    featureTeamName
    frontEndFramework
    backEndFramework
    dataType
    userType
    testAcknowledged
    testAccounts {
      items {
        id
        owner
        dateAdded
        password
        pin
        totpSecret
        userPriority
        username
      }
      nextToken
    }
    dateToTest
    testFrequency
    dateAdded
    abbrev
    color
    securityHeaderName
    securityHeaderValueSet
  }
}
`;
export const updateWebApplication = `mutation UpdateWebApplication($input: UpdateWebApplicationInput!) {
  updateWebApplication(input: $input) {
    id
    name
    url
    render
    owner
    verificationString
    ownershipVerified
    allowedLinks
    deniedLinks
    apiDomains
    maxRequestsPerSecond
    featureTeamName
    frontEndFramework
    backEndFramework
    dataType
    userType
    testAccounts {
      items {
        id
        owner
        dateAdded
        password
        pin
        totpSecret
        userPriority
        username
      }
      nextToken
    }
    tests {
      items {
        id
        owner
        endTime
        functionCount
        startTime
      }
      nextToken
    }
    dateToTest
    testFrequency
    dateAdded
    abbrev
    color
    securityHeaderName
    securityHeaderValueSet
    testAcknowledged
  }
}
`;
export const updateWebApplicationReduced = `mutation UpdateWebApplication($input: UpdateWebApplicationInput!) {
  updateWebApplication(input: $input) {
    id
    securityHeaderName
    securityHeaderValueSet
    testAcknowledged
  }
}
`;
// Re-scope an UNVERIFIED web app's domains in place (pre-verification typo /
// forgotten-domain recovery). Server enforces Admin/Owner-only +
// ownershipVerified == false and re-canonicalises the input; a verified app is
// rejected. Returns the fields the FE model needs to resync after the re-scope.
export const updateWebApplicationDomains = `mutation UpdateWebApplicationDomains($input: UpdateWebApplicationDomainsInput!) {
  updateWebApplicationDomains(input: $input) {
    id
    url
    apiDomains
    ownershipVerified
    verificationString
  }
}
`;
export const deleteWebApplication = `mutation DeleteWebApplication($input: DeleteWebApplicationInput!) {
  deleteWebApplication(input: $input)
}
`;
export const verifyWebAppOwnership = `mutation VerifyWebAppOwnership($input: IDInput!) {
  verifyWebAppOwnership(input: $input) {
    verified
    failedDomain
    message
  }
}
`;
export const startTest = `mutation StartTest($input: StartTestInput!) {
  startTest(input: $input) {
      testid
      message
      success
      retestExpiryDays
      retestExpiresAt
  }
}`;
export const stopTest = `mutation StopTest($input: IDInput!) {
  stopTest(input: $input) {
      testid
      message
      success
  }
}
`;
export const scheduleTest = `mutation ScheduleTest($input: ScheduleTestInput!) {
  scheduleTest(input: $input)
}
`;
export const cancelScheduledTest = `mutation CancelScheduledTest($input: IDInput!) {
  cancelScheduledTest(input: $input)
}
`;
export const changeWebApplicationOwner = `mutation ChangeWebApplicationOwner($input: ChangeWebApplicationOwnerInput!) {
  changeWebApplicationOwner(input: $input)
}
`;
export const createWebApplicationTestUser = `mutation CreateWebApplicationTestUser(
  $input: CreateWebApplicationTestUserInput!
) {
  createWebApplicationTestUser(input: $input) {
    id
    owner
    webappid
    dateAdded
    password
    pin
    totpSecret
    userPriority
    username
  }
}
`;
export const updateWebApplicationTestUser = `mutation UpdateWebApplicationTestUser(
  $input: UpdateWebApplicationTestUserInput!
) {
  updateWebApplicationTestUser(input: $input) {
    id
    owner
    dateAdded
    password
    pin
    totpSecret
    userPriority
    username
  }
}
`;
export const deleteWebApplicationTestUser = `mutation DeleteWebApplicationTestUser(
  $input: DeleteWebApplicationTestUserInput!
) {
  deleteWebApplicationTestUser(input: $input)
}
`;
// updateVulnerabilities mutation and its variants (status, risk, status+risk)
// were removed in the v1 vuln-state-model rework. NIMIS is the sole authority
// on vuln state; the UI has no path that mutates a vuln. The corresponding
// backend mutation will be removed from the schema in the same release.
export const setSecurityHeader = `mutation SetSecurityHeader($input: SetSecurityHeaderInput!) {
  setSecurityHeader(input: $input) {
    securityHeaderName
    securityHeaderValueSet
  }
}
`;